import { type IntlShape } from 'react-intl';

import { webinarCountryMessages } from './webinar-country-messages';

export const WEBINAR_COMPANY_SIZES = [
	'1-10',
	'11-50',
	'51-250',
	'251-1K',
	'1K-5K',
	'5K-10K',
	'10K-50K',
	'50K-100K',
	'100K+',
] as const;

const WEBINAR_COUNTRIES = Object.keys(webinarCountryMessages);

export const getWebinarCountries = (isJapanese: boolean): string[] => {
	const preferredCountry = isJapanese ? 'Japan' : 'United States of America';
	return [preferredCountry, ...WEBINAR_COUNTRIES.filter((country) => country !== preferredCountry)];
};

export const getWebinarCountryOptions = (intl: IntlShape, isJapanese: boolean) =>
	getWebinarCountries(isJapanese).map((value) => {
		const message = webinarCountryMessages[value];
		return { value, label: message ? intl.formatMessage(message) : value };
	});
